import { AnimatePresence } from 'framer-motion'
import React from 'react'
import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'

import { api_gateway } from '../../../conexoes/api'
import { useGlobal } from '../../../stores/useGlobal'
import { fecharJanela } from '../../../utils/alternanciaIcones'
import decryptJWT from '../../../utils/decryptJWT'
import { MascaraCnpj } from '../../../utils/mascarasCampos'

import * as S from './styles'

const BLOQUEIO_IMEI_ATIVO = ['IMEI_AUTO_BIND', 'IMEI_LIST', 'IMEI_PER_SIM']

const slideFromLeft = {
  initial: { opacity: 0, x: -30 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -30 },
  transition: { duration: 0.3 }
}

const slideFromTop = {
  initial: { opacity: 0, y: -10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -10 },
  transition: { duration: 0.3 }
}

function BarraDadosCliente() {
  const { revelarDadosCliente, setRevelarDadosCliente } = useGlobal()
  const visualizarDadosRefresh = useSelector(
    (state) => state.virtueyesState.visualizarDadosRefresh
  )

  const codigoClienteToken = decryptJWT('codigoCliente')

  const { data, isLoading, isError } = useQuery(
    ['dadosCliente', codigoClienteToken, visualizarDadosRefresh],
    async () => {
      const response = await api_gateway.get(
        `/m1/consultar/cliente?cd_pav_cliente=${codigoClienteToken}`
      )
      return response.data.dados?.[0]
    },
    {
      enabled: revelarDadosCliente,
      refetchOnWindowFocus: false
    }
  )

  const handleFecharBarra = () => setRevelarDadosCliente(false)

  const codigoCliente = data?.n0_codigo_cliente ?? '-'
  const razaoSocial = data?.ds_nome ?? '-'
  const cpfCnpj = data?.ds_cnpj ?? '-'
  const bloqueioImei = data?.en_bloquear_por_imei
  const auxBloqueioImei = BLOQUEIO_IMEI_ATIVO.includes(bloqueioImei)
    ? 'Ativo'
    : 'Inativo'

  return (
    <AnimatePresence>
      {revelarDadosCliente && (
        <S.MotionWrapper key="barra-dados" {...slideFromTop}>
          <S.Caixas>
            <S.CaixaTitulo>
              <span>Cliente</span>
            </S.CaixaTitulo>
            <AnimatePresence>
              {auxBloqueioImei === 'Ativo' && (
                <S.MotionBloqueioWrapper key="bloqueio-imei" {...slideFromLeft}>
                  <span>Bloqueio por IMEI: {auxBloqueioImei}</span>
                </S.MotionBloqueioWrapper>
              )}
            </AnimatePresence>
          </S.Caixas>
          <S.Caixa>
            <span>Código: {isLoading || isError ? '-' : codigoCliente}</span>
          </S.Caixa>
          <S.DivisoraVertical />
          <S.Caixa>
            <span>
              Razão social: {isLoading || isError ? '-' : razaoSocial}
            </span>
          </S.Caixa>
          <S.DivisoraVertical />
          <S.Caixa>
            <span>
              CNPJ: {isLoading || isError ? '-' : MascaraCnpj(cpfCnpj)}
            </span>
          </S.Caixa>
          <S.CaixaFechar onClick={handleFecharBarra}>
            <img
              src={fecharJanela()}
              alt="fechar-janela"
              className="botao-fechar-janela-icone-barra-dados-cliente"
            />
          </S.CaixaFechar>
        </S.MotionWrapper>
      )}
    </AnimatePresence>
  )
}

export default BarraDadosCliente
